export const boxShadow = '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)'
export const palette = {
  white: '#fff',
  dark: '#000',
  red: '#e03b3b',
  lightBlue: '#9ab7ec',
  grey: '#e8e8e8',
  grey2: '#c1bfbf',
  grey3: '#3c3b3b',
  backdrop: 'rgba(0, 0, 0, 0.4)',
}
